import { useConversionEngine } from '../hooks/useConversionEngine';

export function ConversionEngineProvider() {
  useConversionEngine();
  return null;
}
